<template>
  <v-sheet width="500" elevation="4" class="pa-4 mb-4" data-section="row">
    <v-checkbox
      dense
      color="primary"
      label="Eingangskontrolle 1"
      v-model="checkbox1"
      @click="(e) => $emit('updateValue', name, checkbox1Name, checkbox1)"
      data-tabindex="1"
    ></v-checkbox>
    <v-checkbox
      dense
      color="primary"
      label="Eingangskontrolle 2"
      v-model="checkbox2"
      @click="(e) => $emit('updateValue', name, checkbox2Name, checkbox2)"
      data-tabindex="2"
    ></v-checkbox>
    <v-checkbox
      dense
      color="primary"
      label="Stammdaten geprüft"
      v-model="checkbox3"
      @click="(e) => $emit('updateValue', name, checkbox3Name, checkbox3)"
      data-tabindex="3"
    ></v-checkbox>
    <v-checkbox
      dense
      color="primary"
      label="Monitoringdaten übernommen"
      v-model="checkbox4"
      @click="(e) => $emit('updateValue', name, checkbox4Name, checkbox4)"
      data-tabindex="4"
    ></v-checkbox>
    <v-checkbox
      dense
      color="primary"
      label="Infoschreiben erstellt"
      v-model="checkbox5"
      @click="(e) => $emit('updateValue', name, checkbox5Name, checkbox5)"
      data-tabindex="5"
    ></v-checkbox>
    <v-checkbox
      dense
      color="primary"
      label="Mitgliederverzeichnis übernommen"
      v-model="checkbox6"
      @click="(e) => $emit('updateValue', name, checkbox6Name, checkbox6)"
      data-tabindex="6"
    ></v-checkbox>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    checkbox1: null,
    checkbox1Name: 'eingangskontrolle_1',
    checkbox2: null,
    checkbox2Name: 'eingangskontrolle_2',
    checkbox3: null,
    checkbox3Name: 'stammdaten_geprueft',
    checkbox4: null,
    checkbox4Name: 'monitoringdaten_uebernommen',
    checkbox5: null,
    checkbox5Name: 'infoschreiben_erstellt',
    checkbox6: null,
    checkbox6Name: 'mitgliederverzeichnis_uebernommen',
  }),
  props: ['data', 'name'],
  emits: ['updateValue'],
  created() {
    this.getCheckboxValues();
  },
  methods: {
    getCheckboxValues() {
      this.checkbox1 = this.data['eingangskontrolle_1'];
      this.checkbox2 = this.data['eingangskontrolle_2'];
      this.checkbox3 = this.data['stammdaten_geprueft'];
      this.checkbox4 = this.data['monitoringdaten_uebernommen'];
      this.checkbox5 = this.data['infoschreiben_erstellt'];
      this.checkbox6 = this.data['mitgliederverzeichnis_uebernommen'];
    },
  },
};
</script>

